import { RouteConfig } from 'react-router-config';
import { RouterSettings } from 'constants/models/routerSettings';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType } from 'constants/enums/insType.enum';
import MainLayout from 'components/MainLayout';
import RouteRedirect from 'components/RouteRedirect';
import Login from 'containers/Login';
import Signup from 'containers/Signup';
import Home from 'containers/Home';
import FavoriteList from 'containers/FavoriteList';
import InsureProcess from 'containers/InsureProcess';
import Unlock from 'containers/Unlock';
import ProductTravelIns from 'containers/Product/ProductTravelIns';
import ProductCarIns from 'containers/Product/ProductCarIns';
import ProductMotoIns from 'containers/Product/ProductMotoIns';
// import ProductMobileDeviceIns from 'containers/Product/ProductMobileDeviceIns';
import ProductFireIns from 'containers/Product/ProductFireIns';
import PromotionsList from 'containers/Promotions/PromotionsList';
import PromotionsInnerPage from 'containers/Promotions/PromotionsInnerPage';
import PromotionsInnerPageA from 'containers/Promotions/PromotionsInnerPageA';
import PromotionsInnerPageB from 'containers/Promotions/PromotionsInnerPageB';
import PromotionsInnerPageC from 'containers/Promotions/PromotionsInnerPageC';
import PromotionsAnnouncement from 'containers/Promotions/PromotionsAnnouncement';
import PromotionsService from 'containers/Promotions/PromotionsService';
import NewsList from 'containers/News/NewsList';
import NewsAnnouncement from 'containers/News/NewsAnnouncement';
import NewsArticle from 'containers/News/NewsArticle';
import NewsRelease from 'containers/News/NewsRelease';
import NewsVideo from 'containers/News/NewsVideo';
import MemberMaintain from 'containers/MemberCenter/MemberMaintain';
import ElectronicPolicy from 'containers/MemberCenter/ElectronicPolicy';
// import QuickClaims from 'containers/MemberCenter/QuickClaims';
import PolicyInquiry from 'containers/MemberCenter/PolicyInquiry';
import PolicyDetailTravel from 'containers/MemberCenter/PolicyInquiry/PolicyDetailTravel';
import PolicyDetailVehicle from 'containers/MemberCenter/PolicyInquiry/PolicyDetailVehicle';
import PolicyDetailFire from 'containers/MemberCenter/PolicyInquiry/PolicyDetailFire';
import PolicyDetailMobileDevice from 'containers/MemberCenter/PolicyInquiry/PolicyDetailMobileDevice';
import CorrectionDownload from 'containers/MemberCenter/CorrectionDownload';
import CorrectionTravel from 'containers/MemberCenter/Correction/CorrectionTravel';
import CorrectionVehicle from 'containers/MemberCenter/Correction/CorrectionVehicle';
import CorrectionFire from 'containers/MemberCenter/Correction/CorrectionFire';
import CorrectionPreview from 'containers/MemberCenter/Correction/CorrectionPreview';
import ClaimService from 'containers/MemberCenter/ClaimService';
import InsureProcessTravel from 'containers/InsureProcess/InsureProcessTravel';
import InsureProcessCar from 'containers/InsureProcess/InsureProcessCar';
import InsureProcessMoto from 'containers/InsureProcess/InsureProcessMoto';
// import InsureProcessMobileDevice from 'containers/InsureProcess/InsureProcessMobileDevice';
import InsureProcessFire from 'containers/InsureProcess/InsureProcessFire';
import SurveyVehicle from 'containers/SurveyVehicle';
import PolicyDetailPet from 'containers/MemberCenter/PolicyInquiry/PolicyDetailPet';
import InsureProcessPet from 'containers/InsureProcess/InsureProcseePet';
import PetIns from 'containers/Product/PetIns';
import Game from 'containers/MemberCenter/Game';
import ProductECarIns from 'containers/Product/ProductECarIns/ProductECarIns';

const rootPath = process.env.PUBLIC_URL;

const routes: RouteConfig[] = [
  {
    path: `${rootPath}${RouterSettings.Unlock}`,
    exact: true,
    component: Unlock
  },
  {
    path: `${rootPath}/`,
    component: MainLayout,
    routes: [
      {
        path: `${rootPath}/`,
        exact: true,
        redirectUrl: `${rootPath}${RouterSettings.Home}`,
        component: RouteRedirect
      },
      {
        path: `${rootPath}${process.env.REACT_APP_PREFIX}`,
        exact: true,
        redirectUrl: `${rootPath}${RouterSettings.Home}`,
        component: RouteRedirect
      },
      {
        path: `${rootPath}${RouterSettings.Login}`,
        component: Login
      },
      {
        path: `${rootPath}${RouterSettings.Signup}`,
        component: Signup
      },
      {
        path: `${rootPath}${RouterSettings.Home}`,
        component: Home
      },
      {
        path: `${rootPath}${RouterSettings.FavoriteList}`,
        login: true,
        component: FavoriteList
      },
      {
        /** 投保作業 - 旅遊險 (補繳費) */
        path: `${rootPath}${RouterSettings.InsureProcess.Travel_UUID}`,
        exact: true,
        component: InsureProcessTravel
      },
      {
        /** 投保作業 - 旅遊險 */
        path: `${rootPath}${RouterSettings.InsureProcess.Travel}`,
        component: InsureProcessTravel
      },
      {
        /** 投保作業 - 汽車險(補繳費) */
        path: `${rootPath}${RouterSettings.InsureProcess.Car_UUID}`,
        exact: true,
        component: InsureProcessCar
      },
      {
        /** 投保作業 - 汽車險 */
        path: `${rootPath}${RouterSettings.InsureProcess.Car}`,
        component: InsureProcessCar
      },
      {
        /** 投保作業 - 機車險(補繳費) */
        path: `${rootPath}${RouterSettings.InsureProcess.Moto_UUID}`,
        exact: true,
        component: InsureProcessMoto
      },
      {
        /** 投保作業 - 機車險 */
        path: `${rootPath}${RouterSettings.InsureProcess.Moto}`,
        component: InsureProcessMoto
      },
      // {
      /** 投保作業 - 行動裝置險 */
      // path: `${rootPath}${RouterSettings.InsureProcess.MobileDevice_Device_Check_Complete}`,
      // exact: true,
      // component: InsureProcessMobileDevice
      // },
      // {
      /** 投保作業 - 行動裝置險 */
      // path: `${rootPath}${RouterSettings.InsureProcess.MobileDevice}`,
      // component: InsureProcessMobileDevice
      // },
      {
        /** 投保作業 - 住宅火險 */
        path: `${rootPath}${RouterSettings.InsureProcess.Fire_UUID}`,
        exact: true,
        component: InsureProcessFire
      },
      {
        /** 投保作業 - 住宅火險 */
        path: `${rootPath}${RouterSettings.InsureProcess.Fire}`,
        component: InsureProcessFire
      },
      {
        /** 投保作業 - 寵物險 */
        path: `${rootPath}${RouterSettings.InsureProcess.Pet}`,
        component: InsureProcessPet
      },
      {
        path: `${rootPath}${RouterSettings.Insure_Process_UUID}`,
        exact: true,
        component: InsureProcess
      },
      {
        path: `${rootPath}${RouterSettings.Insure_Process}`,
        component: InsureProcess
      },
      {
        /** 商品資訊 - 旅遊險首頁 (含優惠代碼) */
        path: `${rootPath}${RouterSettings.Product.TravelIns_ProgramId}`,
        exact: true,
        component: ProductTravelIns
      },
      {
        /** 商品資訊 - 旅遊險首頁 */
        path: `${rootPath}${RouterSettings.Product.TravelIns}`,
        exact: true,
        component: ProductTravelIns
      },
      {
        /** 商品資訊 - 寵物險首頁 */
        path: `${rootPath}${RouterSettings.Product.PetIns}`,
        exact: true,
        component: PetIns
      },
      {
        /** 商品資訊 - 汽車險首頁 (含優惠代碼) */
        path: `${rootPath}${RouterSettings.Product.CarIns_ProgramId}`,
        exact: true,
        component: ProductCarIns
      },
      {
        /** 商品資訊 - 汽車險首頁 */
        path: `${rootPath}${RouterSettings.Product.CarIns}`,
        exact: true,
        component: ProductCarIns
      },
      {
        /** 商品資訊 - 機車險首頁 (含優惠代碼)  */
        path: `${rootPath}${RouterSettings.Product.MotoIns_ProgramId}`,
        exact: true,
        component: ProductMotoIns
      },
      {
        /** 商品資訊 - 機車險首頁 */
        path: `${rootPath}${RouterSettings.Product.MotoIns}`,
        exact: true,
        component: ProductMotoIns
      },
      {
        /** 商品資訊 - 電車險首頁 (含優惠代碼) */
        path: `${rootPath}${RouterSettings.Product.ECarIns_ProgramId}`,
        exact: true,
        component: ProductECarIns
      },
      {
        /** 商品資訊 - 電車險首頁 */
        path: `${rootPath}${RouterSettings.Product.ECarIns}`,
        exact: true,
        component: ProductECarIns
      },
      // {
      /** 商品資訊 - 行動裝置險首頁 (含優惠代碼) */
      // path: `${rootPath}${RouterSettings.Product.MobileDeviceIns_ProgramId}`,
      // exact: true,
      // component: ProductMobileDeviceIns
      // },
      // {
      /** 商品資訊 - 行動裝置險首頁 */
      // path: `${rootPath}${RouterSettings.Product.MobileDeviceIns}`,
      // exact: true,
      // component: ProductMobileDeviceIns
      // },
      {
        /** 商品資訊 - 住火險首頁 (含優惠代碼) */
        path: `${rootPath}${RouterSettings.Product.FireIns_ProgramId}`,
        exact: true,
        component: ProductFireIns
      },
      {
        /** 商品資訊 - 住火險首頁 */
        path: `${rootPath}${RouterSettings.Product.FireIns}`,
        exact: true,
        component: ProductFireIns
      },
      {
        /** 優惠活動 - 優惠活動列表頁 */
        path: `${rootPath}${RouterSettings.Promotions.List}`,
        component: PromotionsList
      },
      {
        /** 優惠活動 - 活動內頁 */
        path: `${rootPath}${RouterSettings.Promotions.InnerPage}`,
        component: PromotionsInnerPage
      },
      {
        /** 優惠活動 - 活動內頁 A */
        path: `${rootPath}${RouterSettings.Promotions.InnerPageA}`,
        component: PromotionsInnerPageA
      },
      {
        /** 優惠活動 - 活動內頁 B */
        path: `${rootPath}${RouterSettings.Promotions.InnerPageB}`,
        component: PromotionsInnerPageB
      },
      {
        /** 優惠活動 - 活動內頁 C */
        path: `${rootPath}${RouterSettings.Promotions.InnerPageC}`,
        component: PromotionsInnerPageC
      },
      {
        /** 優惠活動 - 得獎公告 */
        path: `${rootPath}${RouterSettings.Promotions.Announcement}`,
        component: PromotionsAnnouncement
      },
      {
        /** 優惠活動 - 加值服務 */
        path: `${rootPath}${RouterSettings.Promotions.Service}`,
        component: PromotionsService
      },
      {
        /** 最新消息 - 資訊分享列表頁 */
        path: `${rootPath}${RouterSettings.News.List}`,
        component: NewsList
      },
      {
        /** 最新消息 - 公司公告 */
        path: `${rootPath}${RouterSettings.News.Announcement}`,
        component: NewsAnnouncement
      },
      {
        /** 最新消息 - 部落客文章 */
        path: `${rootPath}${RouterSettings.News.Article}`,
        component: NewsArticle
      },
      {
        /** 最新消息 - 新聞稿 */
        path: `${rootPath}${RouterSettings.News.Release}`,
        component: NewsRelease
      },
      {
        /** 最新消息 - 影音文章 */
        path: `${rootPath}${RouterSettings.News.Video}`,
        component: NewsVideo
      },
      {
        /** 會員中心 - 會員資料維護 */
        path: `${rootPath}${RouterSettings.MemberCenter.MemberMaintain}`,
        login: true,
        component: MemberMaintain
      },
      {
        /** 會員中心 - 電子式保單 */
        path: `${rootPath}${RouterSettings.MemberCenter.ElectronicPolicy}`,
        component: ElectronicPolicy
      },
      // {
      //   /** 會員中心 - 班機延誤快速理賠 */
      //   path: `${rootPath}${RouterSettings.MemberCenter.QuickClaims}`,
      //   component: QuickClaims
      // },
      {
        /** 會員中心 - 抽獎活動 */
        path: `${rootPath}${RouterSettings.MemberCenter.Game}`,
        exact: true,
        login: false,
        component: Game
      },
      {
        /** 會員中心 - 保單查詢 */
        path: `${rootPath}${RouterSettings.MemberCenter.PolicyInquiry}`,
        exact: true,
        login: true,
        component: PolicyInquiry
      },
      {
        /** 會員中心 - 保單明細-旅遊險 */
        path: `${rootPath}${RouterSettings.MemberCenter.PolicyDetailTravel}`,
        login: true,
        component: PolicyDetailTravel
      },
      {
        /** 會員中心 - 保單明細-汽車險 */
        path: `${rootPath}${RouterSettings.MemberCenter.PolicyDetailCar}`,
        insType: InsTypeDefinesEN[InsType.Car],
        login: true,
        component: PolicyDetailVehicle
      },
      {
        /** 會員中心 - 保單明細-機車險 */
        path: `${rootPath}${RouterSettings.MemberCenter.PolicyDetailMoto}`,
        insType: InsTypeDefinesEN[InsType.Moto],
        login: true,
        component: PolicyDetailVehicle
      },
      {
        /** 會員中心 - 保單明細-住宅火險 */
        path: `${rootPath}${RouterSettings.MemberCenter.PolicyDetailFire}`,
        login: true,
        component: PolicyDetailFire
      },
      {
        /** 會員中心 - 保單明細-行動電話險 */
        path: `${rootPath}${RouterSettings.MemberCenter.PolicyDetailMobileDevice}`,
        insType: InsTypeDefinesEN[InsType.MobileDevice],
        login: true,
        component: PolicyDetailMobileDevice
      },
      {
        /** 會員中心 - 保單明細-寵物險 */
        path: `${rootPath}${RouterSettings.MemberCenter.PolicyDetailPet}`,
        insType: InsTypeDefinesEN[InsType.Pet],
        login: true,
        component: PolicyDetailPet
      },
      {
        /** 批改文件下載 */
        path: `${rootPath}${RouterSettings.MemberCenter.CorrectionDownload}`,
        component: CorrectionDownload
      },
      {
        /** 批改申請 - 旅遊險 */
        path: `${rootPath}${RouterSettings.MemberCenter.CorrectionTravel}`,
        insType: InsTypeDefinesEN[InsType.Travel],
        login: true,
        component: CorrectionTravel
      },
      {
        /** 批改申請 - 汽車險 */
        path: `${rootPath}${RouterSettings.MemberCenter.CorrectionCar}`,
        insType: InsTypeDefinesEN[InsType.Car],
        exact: true,
        login: true,
        component: CorrectionVehicle
      },
      {
        /** 批改申請 - 機車險 */
        path: `${rootPath}${RouterSettings.MemberCenter.CorrectionMoto}`,
        insType: InsTypeDefinesEN[InsType.Moto],
        login: true,
        component: CorrectionVehicle
      },
      {
        /** 批改申請 - 住宅火險 */
        path: `${rootPath}${RouterSettings.MemberCenter.CorrectionFire}`,
        insType: InsTypeDefinesEN[InsType.Fire],
        login: true,
        component: CorrectionFire
      },
      {
        /** 批改申請 - 預覽畫面 */
        path: `${rootPath}${RouterSettings.MemberCenter.CorrectionPreview}`,
        login: true,
        component: CorrectionPreview
      },
      {
        /** 理賠服務 - 旅遊險 */
        path: `${rootPath}${RouterSettings.MemberCenter.ClaimServiceTravel}`,
        insType: InsTypeDefinesEN[InsType.Travel],
        login: true,
        component: ClaimService
      },
      {
        /** 理賠服務 - 汽車險 */
        path: `${rootPath}${RouterSettings.MemberCenter.ClaimServiceCar}`,
        insType: InsTypeDefinesEN[InsType.Car],
        login: true,
        component: ClaimService
      },
      {
        /** 理賠服務 - 機車險 */
        path: `${rootPath}${RouterSettings.MemberCenter.ClaimServiceMoto}`,
        insType: InsTypeDefinesEN[InsType.Moto],
        login: true,
        component: ClaimService
      },
      {
        /** 理賠服務 - 住宅火險 */
        path: `${rootPath}${RouterSettings.MemberCenter.ClaimServiceFire}`,
        insType: InsTypeDefinesEN[InsType.Fire],
        login: true,
        component: ClaimService
      },
      {
        /** 理賠服務 - 行動裝置險 */
        path: `${rootPath}${RouterSettings.MemberCenter.ClaimServiceMobileDevice}`,
        insType: InsTypeDefinesEN[InsType.MobileDevice],
        login: true,
        component: ClaimService
      },
      {
        /** 理賠服務 */
        path: `${rootPath}${RouterSettings.MemberCenter.ClaimService}`,
        login: true,
        component: ClaimService
      },
      {
        path: `${rootPath}${RouterSettings.SurveyVehicle_UUID}`,
        exact: true,
        component: SurveyVehicle
      },
      {
        /** 勘車拍照 (僅手機版) */
        path: `${rootPath}${RouterSettings.SurveyVehicle}`,
        component: SurveyVehicle
      },
      {
        path: `${rootPath}/*`,
        redirectUrl: `${rootPath}${RouterSettings.Home}`,
        component: RouteRedirect
      }
    ]
  }
];

export default routes;
